import React from 'react';
import { useFormatAddress } from 'hooks';

import EntityForm from 'components/EntityPage/EntityForm';
import userSchema from '../schema';

const UserForm = ({
  isEditing,
  isProfile,
  isCreating,
  entity,
  entityInfos,
  options,
  onSubmitHandler,
}) => {
  const entityInfosWithScreen = {
    ...entityInfos,
    i18nScreenName: 'UserForm',
  };

  const { users = [], stations = [] } = options;
  /**
   * Transform users objects to fit input
   * { id, value, label }
   */
  const usersForInputs = users.map((user) => {
    const label = `${user.name || ''} - ${user.email}`;
    return { id: user.id, value: user.id, label };
  });

  const stationsForInputs = stations.map((station) => {
    const label = `${station.serialNumber || ''} - ${
      station.name
    } (${useFormatAddress(station.address)})`;
    return { id: station.id, value: station.id, label };
  });

  const entityOptions = {
    usersIds: usersForInputs,
    stationsIds: stationsForInputs,
  };

  // We need to transform
  /**
   * usersIds = ["XXX", "YYY"]
   * into
   * [false, false, "XXX", false, "YYY"]
   */
  const { usersIds = [], stationsIds = [] } = entity;
  const allUsersIds = users.map((user) => {
    if (usersIds.includes(user.id)) {
      return user.id;
    }
    return false;
  });
  const allStationsIds = stations.map((station) => {
    if (stationsIds.includes(station.id)) {
      return station.id;
    }
    return false;
  });
  // Update entity
  const updatedEntity = {
    ...entity,
    usersIds: allUsersIds,
    stationsIds: allStationsIds,
  };

  // Remove false in arrays (usersIds and stationsIds)
  const handleSubmit = (data) => {
    const _usersIds = (data && data.usersIds) || [];
    const _stationsIds = (data && data.stationsIds) || [];

    const onlyUsersIds = _usersIds.filter((userId) => {
      return !!userId;
    });
    const onlyStationsIds = _stationsIds.filter((stationId) => {
      return !!stationId;
    });
    const newData = {
      ...data,
      usersIds: onlyUsersIds,
      stationsIds: onlyStationsIds,
    };
    onSubmitHandler(newData);
  };
  return (
    <EntityForm
      isProfile={isProfile}
      isEditing={isEditing}
      isCreating={isCreating}
      entity={updatedEntity}
      entityInfos={entityInfosWithScreen}
      options={entityOptions}
      onSubmitHandler={handleSubmit}
      schema={userSchema}
      // entity={entity}
      // entityInfos={entityInfos}
      // entitySchema={userSchema}
      // onActivityLogSubmitHandler={onActivityLogSubmitHandler}
    />
  );
};

export default UserForm;
